import React from 'react';
import { CATEGORY_FAMILIES, validCategoryRates } from '../../services/categoryPricing';
import { usd } from '../distributor-cash/cashMoney';

export default function RetailCategoryPrices({ settings, t }) {
  if (
    !settings ||
    (settings.pricingBasis !== 'piece' &&
      !(settings.pricingBasis === undefined && Array.isArray(settings.categoryRates)))
  )
    return Number.isFinite(settings?.ratePerUnit)
      ? t('Legacy retail: {rate} USD per unit', {
          rate: settings.ratePerUnit.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 4,
          }),
        })
      : t('Not set');
  let rates = settings.categoryRates;
  if (typeof rates === 'string') {
    try {
      rates = JSON.parse(rates);
    } catch {
      return t('Not set');
    }
  }
  if (!validCategoryRates(rates, { allowZero: true }) || !rates.length) return t('Not set');
  return (
    <>
      {CATEGORY_FAMILIES.map(({ familyKey, label }) => {
        const rate = rates.find((item) => item.familyKey === familyKey);
        return rate ? (
          <span key={familyKey} style={{ display: 'block' }}>
            {t('{category}: {price} per piece', {
              category: label,
              price: usd(rate.pricePerPieceCents),
            })}
          </span>
        ) : null;
      })}
    </>
  );
}
